import { createApiEffect } from '@/features/api/common/create-api-effect'
import { LoginFxResponse } from '@/features/api/user/types'

export const getStudentTokenFx = createApiEffect<string, LoginFxResponse, any>({
  requestMapper: (studentID) => ({
    method: 'POST',
    url: `/api/user-app/employee/student/${studentID}/`,
  }),
})
